"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutTerminationReportFilterDTO_1 = require("../model/SelloutTerminationReportFilterDTO");

var SelloutTerminationReportFilterDTOConverter_1 = require("./SelloutTerminationReportFilterDTOConverter");
/**
 * Implementation of {@link SelloutTerminationReportFilterDTOConverter}.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportFilterDTOConverterImpl =
/*#__PURE__*/
function (_SelloutTerminationRe) {
  _inherits(SelloutTerminationReportFilterDTOConverterImpl, _SelloutTerminationRe);

  function SelloutTerminationReportFilterDTOConverterImpl() {
    _classCallCheck(this, SelloutTerminationReportFilterDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportFilterDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutTerminationReportFilterDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var schema = SelloutTerminationReportFilterDTO_1.SelloutTerminationReportFilterDTO.schema;
      return new SelloutTerminationReportFilterDTO_1.SelloutTerminationReportFilterDTO(schema.categoryIds.valueOf(source.categoryIds ? conversions.asObjectList(source, 'categoryIds', function (id) {
        return conversions.toClassReferenceId(id);
      }) : null), schema.selloutTypes.valueOfField(source), schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), schema.siteIds.valueOf(source.siteIds ? conversions.asObjectList(source, 'siteIds', function (id) {
        return conversions.toClassReferenceId(id);
      }) : null), schema.productExternalIds.valueOfField(source), schema.endDateFrom.valueOfField(source), schema.endDateTo.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        categoryIds: source.categoryIds ? conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        selloutTypes: source.selloutTypes ? source.selloutTypes.toArray() : null,
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        siteIds: source.siteIds ? conversions.asObjectArray(source, 'siteIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }) : null,
        productExternalIds: source.productExternalIds ? source.productExternalIds.toArray() : null,
        endDateFrom: conversions.fromDate(source.endDateFrom),
        endDateTo: conversions.fromDate(source.endDateTo)
      };
    }
  }]);

  return SelloutTerminationReportFilterDTOConverterImpl;
}(SelloutTerminationReportFilterDTOConverter_1.SelloutTerminationReportFilterDTOConverter);

exports.SelloutTerminationReportFilterDTOConverterImpl = SelloutTerminationReportFilterDTOConverterImpl;